export default {
  // 通用按钮
  buttons: {
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    loading: 'Loading...',
    copy: 'Copy',
    share: 'Share',
    remove: 'Remove',
    login: 'Log in',
    signup: 'Sign up',
    startForFree: 'Start for free',
    check: 'Check',
    contactUsToModifyComments: 'Contact us to modify comments',
    confirmDelete: 'Confirm Delete',
    goBack: 'Go back',
    approve: 'Approve',
  },

  // 登录相关
  auth: {
    dontHaveAccount: "Don't have an account?",
    signUp: 'Sign up',
    needHelp: 'Need help? Contact us at',
    supportEmail: 'support@aha.inc'
  },

  // 移动端登录相关
  mobileAuth: {
    login: 'Login',
    pleaseLogin: 'Please log in',
    usingDesktopBrowser: 'using a desktop browser',
    getStartedMessage: 'To get started with the site, please open a desktop browser to access Aha.',
    questionsMessage: 'If you have any questions or need assistance, please contact ',
    joinDiscord: 'Join Aha\'s Discord'
  },
  
  // 通用状态
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    success: 'Success',
    error: 'Error',
  },
  
  // 通用消息
  messages: {
    copySuccess: 'Copy success.',
    copyFail: 'Copy fail.',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    confirmDelete: 'Are you sure you want to delete?',
    noData: 'No data available',
    loading: 'Loading...',
  },
  
  // 通用标签
  labels: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    amount: 'Amount',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
  },
  signOut: 'Sign out',
  learnMore: 'Learn more',
  YouTube: 'YouTube',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
  LinkedIn: 'LinkedIn',
  Twitter: 'Twitter/X',
  collected: 'Collected',
  reviews: 'Reviews',
  loadMore: 'Load More',
  underReview: 'Under Review',
  reviewNotPassed: 'Review not passed',
  gotIt: 'Got it',
  influencers: 'influencers',
  report: 'Report',
  template: 'Template',
  refreshPage: 'Please refresh the page and try again.',
  reject: 'Reject',
  pendingActions: 'pending actions',
  followers: 'Followers',
  days: 'days',
  ok: 'OK',
};
